"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _components = require("../../../components");

var _hooks = require("../../../hooks");

var _classnames = _interopRequireDefault(require("classnames"));

var _ModifierItemModule = _interopRequireDefault(require("./ModifierItem.module.scss"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ModiifierItem = (0, _styledComponents["default"])(function (_ref) {
  var cellType = _ref.cellType,
      name = _ref.name,
      price = _ref.price,
      quantity = _ref.quantity,
      multiSelect = _ref.multiSelect,
      onClick = _ref.onClick,
      className = _ref.className,
      increment = _ref.increment,
      decrement = _ref.decrement;

  var _useTemplate$useCell = _hooks.useTemplate.useCell(cellType),
      buttons = _useTemplate$useCell.buttons,
      labelTextStyles = _useTemplate$useCell.labelTextStyles,
      views = _useTemplate$useCell.views;

  return /*#__PURE__*/_react["default"].createElement(_components.View, {
    type: views.background,
    Component: "li",
    className: "".concat(_ModifierItemModule["default"].item, " ").concat(className),
    dataTest: name
  }, /*#__PURE__*/_react["default"].createElement("div", {
    type: "button",
    className: _ModifierItemModule["default"].name,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.primary
  }, name)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"].price
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: price
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary
  }, price)), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: multiSelect
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_ModifierItemModule["default"].selectors, quantity && _ModifierItemModule["default"].selected)
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: quantity !== 0
  }, /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    type: buttons.unselected,
    className: (0, _classnames["default"])(_ModifierItemModule["default"]["quantity-btn"], _ModifierItemModule["default"].minus),
    onClick: decrement
  }, "-")), /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    type: quantity ? buttons.selected : buttons.unselected,
    className: (0, _classnames["default"])(_ModifierItemModule["default"]["quantity-btn"], _ModifierItemModule["default"].plus),
    onClick: increment
  }, quantity === 0 ? "+" : quantity))), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: !multiSelect
  }, /*#__PURE__*/_react["default"].createElement(_components.Radio, {
    type: buttons.unselectedSolid,
    className: _ModifierItemModule["default"].radio,
    value: quantity,
    onChange: onClick
  }))));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-bottom-color: ", "\n"])), function (props) {
  return props.theme.colors.alternateGray;
});

var _default = /*#__PURE__*/_react["default"].memo(ModiifierItem);

exports["default"] = _default;